import { AxiosResponse } from 'axios';
import { IService } from 'src/core/infrastructure';
import request from '../request';
import {
  childDataRequest,
  childListResponse,
  insertChildRequest,
} from './types';

export const getCreateChild = async (
  dataBody: insertChildRequest,
): Promise<any> => {
  const data: IService<insertChildRequest> = {
    method: 'POST',
    relativePath: '/children-insert',
    data: dataBody,
  };

  const response = await request.requestService<
    AxiosResponse<any>,
    insertChildRequest
  >(data);

  return response.data;
};

export const getChildList = async (): Promise<any> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };

  const data: IService<any> = {
    method: 'GET',
    relativePath: 'children-list',
    headers: header,
  };

  const response = await request.requestService<AxiosResponse<any[]>, any>(
    data,
  );

  return response.data;
};

export const getChildData = async (params: any): Promise<any> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };

  const data: IService<any> = {
    method: 'POST',
    relativePath: `children-view`,
    headers: header,
    data: {
      child_id: params,
    },
  };

  const response = await request.requestService<AxiosResponse<any>, any>(data);
  return response.data;
};

export const editChildData = async (dataBody: any): Promise<any> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };

  const data: IService<childDataRequest> = {
    method: 'POST',
    relativePath: `/children-update`,
    headers: header,
    data: {
      child_id: dataBody.child_id,
      child_name: dataBody.child_name,
      birth_date: dataBody.birth_date,
      gender_id: dataBody.gender_id,
      photo: dataBody.photo || '',
    },
  };

  const response = await request.requestService<AxiosResponse<any>, any>(data);
  return response.data;
};
